import { INITIALIZE_APPLICATION } from '../constants/action.types'

const initialState = {
  user: {},
  siteKey: undefined
}

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_APPLICATION: {
      const { user = {}, siteKey } = action.payload

      return {
        ...state,
        user: (({ name, email }) => ({ name, email }))(user),
        siteKey
      }
    }
    default:
      return state
  }
}
